export class Card {
  public id: number;
  public is_default: boolean;
  public name: string;
  public number: string;
  public offer_exp_date: string;
  public img = '/assets/img/icons/belcard.svg';
  constructor(item?) {
    this.update(item);
  }

  public update(el): void {
    if (el) {
      Object.assign(this, el);
    }
    const fs = this.number ? this.number.charAt(0) : '4';
    switch (fs) {
      case '4':
        this.img = '/assets/img/icons/visa.svg';
        break;
      case '2':
      case '5':
        this.img = '/assets/img/icons/mastercard.svg';
        break;
      case '9':
        this.img = '/assets/img/icons/belcard.svg';
        break;
      case '6':
        this.img = '/assets/img/icons/maestro.svg';
        break;
    }
  }
}
